import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActivityFeedBadgingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActivityFeedBadgingQuery = { __typename?: 'Query', getActivityFeedBadgeCount: number };

export type GetNewNotificationsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type GetNewNotificationsSubscription = { __typename?: 'Subscription', newAfNotification: { __typename?: 'AFNotification', id: string } };


export const ActivityFeedBadgingDocument = gql`
    query ActivityFeedBadging {
  getActivityFeedBadgeCount
}
    `;

/**
 * __useActivityFeedBadgingQuery__
 *
 * To run a query within a React component, call `useActivityFeedBadgingQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityFeedBadgingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityFeedBadgingQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityFeedBadgingQuery(baseOptions?: Apollo.QueryHookOptions<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>(ActivityFeedBadgingDocument, options);
      }
export function useActivityFeedBadgingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>(ActivityFeedBadgingDocument, options);
        }
export function useActivityFeedBadgingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>(ActivityFeedBadgingDocument, options);
        }
export type ActivityFeedBadgingQueryHookResult = ReturnType<typeof useActivityFeedBadgingQuery>;
export type ActivityFeedBadgingLazyQueryHookResult = ReturnType<typeof useActivityFeedBadgingLazyQuery>;
export type ActivityFeedBadgingSuspenseQueryHookResult = ReturnType<typeof useActivityFeedBadgingSuspenseQuery>;
export type ActivityFeedBadgingQueryResult = Apollo.QueryResult<ActivityFeedBadgingQuery, ActivityFeedBadgingQueryVariables>;
export const GetNewNotificationsDocument = gql`
    subscription GetNewNotifications {
  newAfNotification {
    id
  }
}
    `;

/**
 * __useGetNewNotificationsSubscription__
 *
 * To run a query within a React component, call `useGetNewNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetNewNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewNotificationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetNewNotificationsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetNewNotificationsSubscription, GetNewNotificationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetNewNotificationsSubscription, GetNewNotificationsSubscriptionVariables>(GetNewNotificationsDocument, options);
      }
export type GetNewNotificationsSubscriptionHookResult = ReturnType<typeof useGetNewNotificationsSubscription>;
export type GetNewNotificationsSubscriptionResult = Apollo.SubscriptionResult<GetNewNotificationsSubscription>;